import React from "react";
import html from "../assets/html.png";
import css from "../assets/css.png";
import javascript from "../assets/javascript.png";
import reactImage from "../assets/react.png";
import graphql from "../assets/graphql.png";
import tailwind from "../assets/tailwind.png";
import sql from "../assets/sql.png";
import mongodb from "../assets/mongodb.png";
import nodejs from "../assets/nodejs.png";
import materialui from "../assets/materialui.png";
import express from "../assets/express.png";
import typescript from "../assets/typescript.png";
import dotnet from "../assets/dotnet.png";
import csharp from "../assets/csharp.png";

const Experience = () => {
  const techs = [
    {
      id: 1,
      src: sql,
      title: "SQL",
    },
    {
      id: 2,
      src: dotnet,
      title: ".NET",
    },
    {
      id: 3,
      src: csharp,
      title: "C#",
    },
    {
      id: 5,
      src: reactImage,
      title: "React",
    },
    {
      id: 6,
      src: typescript,
      title: "Typescript",
    },
    {
      id: 7,
      src: javascript,
      title: "Javascript",
    },
    {
      id: 8,
      src: nodejs,
      title: "Node.js",
    },
    {
      id: 9,
      src: express,
      title: "Express.js",
    },
    {
      id: 10,
      src: graphql,
      title: "GraphQL",
    },
    {
      id: 11,
      src: mongodb,
      title: "MongoDB",
    },
    {
      id: 12,
      src: tailwind,
      title: "Tailwind",
    },
    {
      id: 13,
      src: materialui,
      title: "Material UI",
    },
    {
      id: 14,
      src: html,
      title: "HTML",
    },
    {
      id: 15,
      src: css,
      title: "CSS",
    },
  ];

  return (
    <div
      name="experience"
      id="experience"
      className="w-full min-h-screen bg-[#0a192f]"
    >
      <div className="max-w-screen-lg mx-auto p-4 flex flex-col justify-center h-full w-full text-white">
        <div>
          <p className="text-4xl font-bold inline border-b-4 border-pink-600">
            Skills
          </p>
          <p className="text-gray-500 py-4 max-w-xlg">
            These are the technologies I've worked with
          </p>
        </div>

        <div className="w-full grid grid-cols-2 sm:grid-cols-4 gap-4 text-center py-8">
          {techs.map(({ id, src, title }) => (
            <div
              key={id}
              className={`shadow-md shadow-[#040c16] hover:scale-105 duration-500 flex flex-col items-center justify-center`}
            >
              <img src={src} alt={title} className="w-20 mx-auto" />
              <p className="my-4">{title}</p>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default Experience;